import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";

class VehicleLoadUnloadList extends Component {
  state = {
    DeliveryPerson: [],
    LoadingSrNo: [],
    Packing: [],
    TaxName: [],
    autoEnableDisalbe_Col_Info: [],
    formData: {
      dtpFromDate: get_30DaysBack_FromCurrentDate(),
      dtpToDate: get_YMD_from_SYS(new Date()),
      cmbDRP: "All",
    },
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "dat_unloaddateDMY", label: "Unload Date" },
      { id: "vac_ledgername", label: "Delivery Responsible Person" },
      { id: "vac_storename", label: "Store Name" },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_unit", label: "Unit" },
      { id: "dec_unloadqty", label: "Quantity" },
      { id: "vac_unloadremark", label: "Remark" },
    ],
    rows: [],
    // actionList: [
    //   {
    //     name: "Edit",
    //     icon: <Edit />,
    //     link: "VehicleLoadUnloadList:",
    //     actionType: "AlertResponsive",
    //   },
    //   {
    //     name: "Delete",
    //     icon: <Delete />,
    //     link: "VehicleLoadUnloadList:",
    //     actionType: "AlertResponsive",
    //   },
    // ],
    searchData: {
      dat_unloaddateDMY: "",
      vac_ledgername: "",
      vac_storename: "",
      vac_itemname: "",
      vac_unit: "",
      dec_unloadqty: "",
      vac_unloadremark: "",
    },
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    keyColumn: [
      "dat_unloaddateDMY",
      "vac_ledgername",
      "vac_storename",
      "vac_itemname",
      "vac_unit",
      "dec_unloadqty",
      "vac_unloadremark",
    ],
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Unload List";
    this.props.setActiveMenu("UnloadList");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle

  handleARDonActionClick = (row) => {
    // console.log("values", values)
    const bint_acid = row.bint_acid,
      bint_loadingsrno = row.bint_loadingsrno,
      bint_acyear = localStorage.getItem("ACY"),
      actionName = row.actionName;
    if (actionName === "Edit") {
      this.props.navigateTo(
        "VehicleLoadEntry/:" +
          bint_acid +
          ":" +
          bint_loadingsrno +
          ":" +
          bint_acyear
      );
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Order No. : " + bint_loadingsrno + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLoadingEntry(
                bint_acid,
                bint_loadingsrno,
                bint_acyear
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleOnNewEntryClick = () => {
    this.props.navigateTo("VehicleUnload");
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          // (this.state.searchData.bint_loadingsrno.length === 0 ||
          //     (row["bint_loadingsrno"] &&
          //         row["bint_loadingsrno"] == this.state.searchData.bint_loadingsrno)) &&
          (this.state.searchData.dat_unloaddateDMY.length === 0 ||
            (row["dat_unloaddateDMY"] &&
              row["dat_unloaddateDMY"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dat_unloaddateDMY.toLowerCase()
                ))) &&
          (this.state.searchData.vac_ledgername.length === 0 ||
            (row["vac_ledgername"] &&
              row["vac_ledgername"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_ledgername.toLowerCase()
                ))) &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.dec_unloadqty.length === 0 ||
            (row["dec_unloadqty"] &&
              row["dec_unloadqty"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_unloadqty.toLowerCase()
                ))) &&
          (this.state.searchData.vac_unloadremark.length === 0 ||
            (row["vac_unloadremark"] &&
              row["vac_unloadremark"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_unloadremark.toLowerCase()
                )))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnChangeAutoEnableDisalbe_ColIdxs = (autoEnableDisalbe_Col_Info) => {
    this.setState({ autoEnableDisalbe_Col_Info });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion handle

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "dat_unloaddateDMY",
        label: "Unload Date",
        value: this.state.searchData.dat_unloaddateDMY,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_ledgername",
        // items: this.state.vac_ledgername,
        label: "Delivery Responsible Person",
        value: this.state.searchData.vac_ledgername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "250",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_storename",
        // items: this.state.vac_storename,
        label: "Store Name",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        label: "Unit",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_unloadqty",
        label: "Quantity",
        value: this.state.searchData.dec_unloadqty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_unloadremark",
        label: "Remark",
        value: this.state.searchData.vac_unloadremark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateUnloadlist = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else if (this.state.formData.cmbDRP <= 0) {
      this.props.toastErrorMsg("Select Delivery Responsible Person", "cmbDRP");
    } else if (
      !isValidItem(
        this.state.DeliveryPerson,
        "vac_ledgername",
        this.state.formData.cmbDRP
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Delivery Responsible Person",
        "cmbDRP"
      );
    } else {
      result = true;
    }
    return result;
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Unloading",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      let reqData = {
        Op: "UnloadingList",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
        vac_drp: this.state.formData.cmbDRP,
      };
      fetchLoadUnload(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          let rows = res.data.UnloadingList,
            rowsCount = rows.length,
            DeliveryPerson = res.data.LedgerNameList;
          this.setState(
            {
              dataLoadStatus: true,
              rows,
              rowsCount,
              DeliveryPerson,
            },
            () => {}
          );
        })
        .catch((error) => {
          this.props.toastMsg(
            "error",
            "Unkonwn Error occured in onFormLoad. " + error
          );
        });
      document.getElementById("dtpFromDate").focus();
    });
  };

  onFormLoad = () => {
    const { fromdate, todate } = getlocalstoragedate("Unloading");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  handleOnList = () => {
    if (this.validateUnloadlist()) {
      this.onFormLoad();
    }
  };

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    return (
      <from>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Unloading List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                onClick={() => {
                  this.setfrom_todate(true);
                }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              label="From Date"
              width="170"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              accountYear={localStorage.getItem("ACY")}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpToDate"
            />
          </Grid>

          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date"
              width="170"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              accountYear={localStorage.getItem("ACY")}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbDRP"
            />
          </Grid>

          <Grid item>
            <CtCmbEditable
              id="cmbDRP"
              label="Delivery Responsible Person*"
              items={this.state.DeliveryPerson}
              value={this.state.formData.cmbDRP}
              handleOnChange={this.handleOnChange}
              width={290}
              colID="vac_ledgername"
              maxLength={50}
              defaultAction={this.handleOnList}
            />
          </Grid>
          {/* <Grid item>
            <CtBtn label="List" onClick={this.onFormload} />
          </Grid> */}

          <Grid item>
            <CtBtn
              label="List"
              //  onClick={this.handleOnList}
              onClick={() => {
                this.trimFormData(() => {
                  this.handleOnList();
                });
              }}
            />
          </Grid>
        </Grid>
        <br />

        <TableList
          toastMsg={this.props.toastMsg}
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Loading Entry"
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </from>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(VehicleLoadUnloadList))));
